export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (window.fbsConsent !== 'granted') return;
  if (typeof window.gtag === 'function' && window.GA_MEASUREMENT_ID) {
    window.gtag('event', name, params);
  }
}

export function installClickTracking() {
  if (typeof document === 'undefined' || document.body.dataset.fbsTracking) return;
  document.body.dataset.fbsTracking = 'true';

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:')) trackEvent('phone_click', { link_url: href });
    else if (href.includes('wa.me') || href.includes('whatsapp')) {
      trackEvent('whatsapp_click', { link_url: href });
    } else if (href.startsWith('mailto:')) {
      trackEvent('email_click', { link_url: href });
    } else if (href.includes('bark.com') || href.includes('google.com/maps')) {
      trackEvent('review_click', { link_url: href });
    }
  });
}
